<template>
	<div>
		<div v-if="inPageTabs.length > 1 || playerTab || showSessionHistoryButton"
			class="flex flex-wrap items-center gap-3 mb-3">
			<TabGroup v-if="inPageTabs.length > 1" type="segmented">
				<TabItem v-for="(viewItem, $index) in inPageTabs" :key="$index"
					:is-active="!!(viewItem.viewName && $route.name === viewItem.viewName)"
					@click="onAnalyticsTabClick(viewItem)">
					<span v-if="viewItem.name">{{ viewItem.name }}</span>
					<span v-else-if="viewItem.nameHtml" v-html="viewItem.nameHtml" />
				</TabItem>
			</TabGroup>
			<h3 v-else-if="inPageTabs.length === 1 && showSessionHistoryButton"
				class="capitalize text-base font-semibold text-white mb-0">
				{{ inPageTabs[0].name }}
			</h3>
			<div class="flex items-center gap-2 ml-auto">
				<FormButton v-if="playerTab" type="secondary" size="md" @click="onAnalyticsTabClick(playerTab)">
					Player Analytics
					<icon-base class="ml-1.5" width-view-box="16" height-view-box="16">
						<icon-link-external />
					</icon-base>
				</FormButton>
				<FormButton v-if="showSessionHistoryButton && (stream.type === 'live' || stream.type === 'restream')"
					size="md" :to="{ name: 'StreamsManageAnalyticsStreamSessions' }">
					Stream Session History
				</FormButton>
				<FormButton v-else-if="showSessionHistoryButton && stream.type === 'subsecond'"
					size="md" :to="{ name: 'SubSecondManageAnalyticsStreamSessions' }">
					Stream Session History
				</FormButton>
			</div>
		</div>
		<router-view v-slot="{ Component }">
			<component :is="Component" :stream="stream" :stream-alive="streamAlive" :media-pulse="mediaPulse" />
		</router-view>
	</div>
</template>

<script>
import FormButton from '../../components/Atoms/FormButton.vue';
import TabGroup from '../../components/Atoms/TabGroup.vue';
import TabItem from '../../components/Atoms/TabItem.vue';
import IconBase from '../../components/icon/IconBase.vue';
import IconLinkExternal from '../../components/icon/IconLinkExternal.vue';

export default {
	name: 'StreamManageAnalytics',
	components: {
		FormButton,
		TabGroup,
		TabItem,
		IconBase,
		IconLinkExternal,
	},
	props: {
		stream: {
			type: Object,
			required: true,
			validator(v) {
				return Object.prototype.hasOwnProperty.call(v, '_id');
			}
		},
		streamAlive: {
			type: Boolean
		},
		mediaPulse: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			childViewList: [
				{
					streamType: 'live',
					name: 'input health',
					viewName: 'StreamsManageAnalyticsInputHealthCharts',
				},
				{
					streamType: 'subsecond',
					name: 'input health',
					viewName: 'SubSecondManageAnalyticsInputHealthCharts',
				},
				{
					streamType: 'restream',
					name: 'input health',
					viewName: 'StreamsManageAnalyticsInputHealthCharts',
				},
				{
					// Opens the account-wide player analytics dashboard in a new tab
					// (see onClickNavItem); it is not a nested route.
					streamType: 'live',
					name: 'player',
					skip: true,
				},
			]
		}
	},
	computed: {
		showSessionHistoryButton() {
			const p = this.$route.path;
			const inInputHealth = p.includes('input-health') && !p.includes('input-health/session');
			return inInputHealth && ['live', 'restream', 'subsecond'].includes(this.stream.type);
		},
		inPageTabs() {
			return this.childViews.filter(v => v.name !== 'player');
		},
		playerTab() {
			return this.childViews.find(v => v.name === 'player');
		},
		childViews() {
			return (this.stream && this.childViewList.filter(v => {
				if (v.name === 'paywall' && !this.paywallFeature) {
					return false;
				}

				const isIncluded = v.streamType === this.stream.type;
				return isIncluded && v.validate ? v.validate(this.stream) : isIncluded;
			}));
		},
	},
	methods: {
		onAnalyticsTabClick(item) {
			if (item.name === 'player') {
				this.onClickNavItem(null, item)
				return
			}
			if (item.viewName && !item.skip) {
				this.$router.push({ name: item.viewName })
			}
		},
		onClickNavItem(e, item) {
			if(item.name === 'player') {
				const route = this.$router.resolve({ name: 'AnalyticsDashboardWithRoute', params: { videoId: this.stream.key }, query: { stream: true } });
				window.open(route.href, '_blank');
			}
		}
	}
};
</script>

<style scoped></style>
